import React from 'react';
import { Box, Typography } from '@mui/material';
import TeamWebhooks from './TeamWebhooks';
import UserWebhooks from './UserWebhooks';

const WebhooksIndex = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Team Webhooks
      </Typography>
      <TeamWebhooks />

      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        User Webhooks
      </Typography>
      <UserWebhooks />
    </Box>
  );
};

export default WebhooksIndex;
